module.exports = __webpack_public_path__ + "static/img/cpzs_xe.49bfc6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cpzs_xe.png
// module id = WUBj
// module chunks = 0